// orderTypeExceptionValidations.ts //M10-12407
import * as yup from "yup";

export const orderTypeExceptionValidations = (selectedData: any) => {
  const schema = yup.object().shape({
    counterCode: yup
      .string()
      .nullable()
      .trim(),

    locationCode: yup
      .number()
      .nullable()
      .when("counterCode", {
        is: (val: any) => !!val,
        then: (schema) => schema.required("Location Code is required when Counter Code is provided"),
        otherwise: (schema) => schema.nullable(),
      }),

    companyCode: yup
      .string()
      .required("Company Code is required")
      .test(
        "selected-company",
        "Data inconsistent with the company selected.",
        (value) => value == selectedData?.code?.code
      ),

    orderType: yup.string().required("Order Type is required"),

    state: yup.string().nullable(),
    companyStockistCode: yup.string().nullable(),
    itemCode: yup.string().nullable(),
    counterLinkType: yup.string().nullable(),
    activeStatus: yup
      .string()
      .required("Active Status field is required"),
  });

  return schema;
};
//M10-12407